import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Add critical resource hints
const root = document.getElementById("root")!;

createRoot(root).render(<App />);
